import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { PermissionArea } from './auth.type';

export const permissionGuard = (area: PermissionArea): CanActivateFn => () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.getCurrentUser()) {
    router.navigate(['/login']);
    return false;
  }

  if (!authService.canRead(area)) {
    router.navigate(['/dashboard']);
    return false;
  }

  return true;
};
